import { Fragment, memo } from 'react';
import Dialog from '@mui/material/Dialog';
import { SmallHeightDivider, StyledButton } from '../../theme/Styles';
import {
  Container,
  BodyText,
  Title,
  ButtonsContainer,
  Header,
  StyledAnnouncementOutlinedIcon,
  CenterContainer,
  TextContainer,
  IconDivider
} from './styles/ImportantInformationModalStyles';

export default function ImportantInformationModal({ open, content, buttonTitle, buttonClick, onBackDropClick, onCloseClick, CloseTitle, CloseButton }) {

  return (
    <Dialog
      open={open}
      onClose={onCloseClick}
      onBackdropClick={onBackDropClick}
      sx={{zIndex:99999999999999999}}
    >
      <Container>

        <Header>
          <CenterContainer>
            <StyledAnnouncementOutlinedIcon />
            <IconDivider />
            <Title>Información Importante</Title>
          </CenterContainer>
        </Header>
        <CenterContainer>
          <TextContainer>
            <BodyText>
              {content}
            </BodyText>
          </TextContainer>
        </CenterContainer>
        <CenterContainer>
          <ButtonsContainer CloseButton={CloseButton}>
            <StyledButton onClick={buttonClick}>{buttonTitle}</StyledButton>

            {CloseButton &&
              <Fragment>
                <div style={{ width: '50%' }} />
                <StyledButton onClick={onCloseClick}>{CloseTitle}</StyledButton>
              </Fragment>
            }
          </ButtonsContainer>
        </CenterContainer>
        <SmallHeightDivider />
      </Container>
    </Dialog>
  );
}